import React, { lazy } from "react";

const LazyTranslate = lazy(() => import("./CreateFileTranslationRequest"));

const Translate = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyTranslate {...props} />;

export default Translate;
